<div
  class="table-scroll-wrapper"
  [style.--table-scroll-max-height]="
    maxHeightPx() ? maxHeightPx() + 'px' : null
  "
  [style.--table-scroll-button-top]="buttonTopOffsetPx() + 'px'"
  [style.--table-scroll-button-bottom]="buttonBottomOffsetPx() + 'px'"
>
  @if (horizontalScrollVisible && !loading()) {
    <nav class="table-scroll-nav">
      @if (!scrollOnVeryLeft) {
        <button
          type="button"
          class="table-scroll-button left"
          [attr.aria-label]="leftButtonAriaLabel()"
          (click)="scrollLeft()"
        >
          <i class="pi pi-chevron-left"></i>
        </button>
      }

      @if (!scrollOnVeryRight) {
        <button
          type="button"
          class="table-scroll-button right"
          [attr.aria-label]="rightButtonAriaLabel()"
          [style.right.px]="rightScrollButtonOffsetPx"
          (click)="scrollRight()"
        >
          <i class="pi pi-chevron-right"></i>
        </button>
      }
    </nav>
  }

  <ng-content />
</div>
